export interface DialogsState {
  dialogSteps: DialogStepWrap;
}

export class DialogStepWrap {
  [x: string]: DialogStep;
}

export class DialogStep {
  form?: any | undefined;
  data?: any | undefined;
}
